import React from 'react';
import PageHeader from '../Headers/PageHeader';
// import { PageHeaderEndSideComponentType } from "../../constants/types/componentsTypes/PageHeadertypes";
// import Breadcrumbs from "../../components/Navigation/Breadcrumbs";

export interface PageHeaderEndSideComponentType {
  element: JSX.Element;
  permission?: string[];
}

interface Props {
  title: string | JSX.Element;
  endSideComponent?: PageHeaderEndSideComponentType[];
  breadCrumbsLinks?: { title: string; link?: string }[];
  children: JSX.Element;
  withoutRightPadding?: boolean;
  bottomSidecomponent?: JSX.Element;
}

const PageLayoutsContainer = ({
  title,
  endSideComponent,
  breadCrumbsLinks,
  children,
  withoutRightPadding,
  bottomSidecomponent,
}: Props) => {
  return (
    <div className="flex flex-col  min-w-0 h-full">
      <PageHeader
        title={title}
        endSideComponent={endSideComponent}
        bottomSidecomponent={bottomSidecomponent}
        breadCrumbsLinks={breadCrumbsLinks}
      />
      <div className={`p-4 flex-grow h-full  relative `}>{children}</div>
    </div>
  );
};

export default PageLayoutsContainer;
